

export default {

    Priority : {
        
        EXTRALOW : -2,
        LOW      : -1,
        NORMAL   : 0,
        HIGHT    : 1,
        EXTRAHIGH: 2
        
    },
    
    Events : {
        AJAX_FORM_REQUESTED : 'ajax.form.requested',
        AJAX_FORM_RESPONDED : 'ajax.form.responded',
    }
        
}